import * as React from 'react';

import { ca } from '@cian/analytics';
import { EScrollingBlocks } from '../../constants/scrollingBlocks';

export enum EBlockName {
  ExtendedFilters = 'extended_filters',
  EstimationHistory = 'estimation_history',
  AboutHouse = 'about_home',
  OffersHistory = 'history_block',
  EstimationReportBanner = 'estimation_report_banner',
  PriceDynamic = 'price_dynamic',
  PriceDemand = 'price_demand',
}

export function trackBasedView(label: EBlockName) {
  return () => {
    ca('teaser', {
      product: {
        name: label,
      },
    });
  };
}

export const trackPreciseFiltersView = trackBasedView(EBlockName.ExtendedFilters);
export const trackEstimationChartInView = trackBasedView(EBlockName.EstimationHistory);
export const trackAboutHouseView = trackBasedView(EBlockName.AboutHouse);
export const trackOffersHistoryView = trackBasedView(EBlockName.OffersHistory);
export const trackEstimationReportBannerView = trackBasedView(EBlockName.EstimationReportBanner);
export const trackPriceDynamicView = trackBasedView(EBlockName.PriceDynamic);
export const trackSupplyDemandView = trackBasedView(EBlockName.PriceDemand);

export const useAccordionItemsClick = () => {
  const [blocksViewed, setBlockViewed] = React.useState<EScrollingBlocks[]>([]);

  return React.useCallback(
    (itemIndex: EScrollingBlocks) => {
      if (blocksViewed.includes(itemIndex)) {
        return;
      }
      switch (itemIndex) {
        case EScrollingBlocks.AboutHome:
          trackAboutHouseView();
          break;
        case EScrollingBlocks.OffersHistory:
          trackOffersHistoryView();
          break;
      }

      setBlockViewed([...blocksViewed, itemIndex]);
    },
    [blocksViewed],
  );
};

export function trackExistBlock(condition: boolean, blockName: EBlockName) {
  if (condition) {
    ca('teaser', {
      product: {
        name: `${blockName}_exist`,
      },
    });
  }
}
